import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button"];
  static values = { text: String };

  copy() {
    // Either a plain value passed in (the inline "copy this email" buttons) or
    // the readonly input the token/feed-URL fields wrap.
    const text = this.hasTextValue ? this.textValue : this.sourceTarget.value;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => this.showSuccess());
    } else {
      // Fallback for non-HTTPS (local dev)
      this.copyWithExecCommand(text);
      this.showSuccess();
    }
  }

  // execCommand can only copy a selection, so a text value with no source input
  // needs an off-screen field to select.
  copyWithExecCommand(text) {
    if (this.hasSourceTarget) {
      this.sourceTarget.select();
      document.execCommand("copy");
      return;
    }

    const scratch = document.createElement("textarea");
    scratch.value = text;
    scratch.setAttribute("readonly", "");
    scratch.style.position = "absolute";
    scratch.style.left = "-9999px";
    document.body.appendChild(scratch);
    scratch.select();
    document.execCommand("copy");
    scratch.remove();
  }

  showSuccess() {
    const icon = this.buttonTarget.querySelector("i");
    icon.className = "bi bi-check-lg";
    setTimeout(() => {
      icon.className = "bi bi-clipboard";
    }, 2000);
  }
}
